export default __webpack_public_path__ + "static/icon-responsible-production-3924713e3c7c4aeb680bcf17b328b3fd.svg";